import * as CL from '@design-system/component-library';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { additionalInformationMsg, domainMsg, selectProductMsg, t } from '../../../common/i18n/index.js';
import { TextInput } from '../../../common/react-hook-form/fields/index.js';
import { CompanyAndContactDetails, CustomFormErrorAndButton } from '../CustomFormFields.js';
import { CustomFormDomainSearch } from '../partials/CustomFormDomainSearch.js';
import { CustomFormRadio } from '../partials/CustomFormRadio.js';
import { PriceSummary } from '../partials/PriceSummary.js';
import type { Price } from '../../../generated/api/price.js';
import type { CustomFormProps } from '../CustomForm.js';
import type { CustomFormRadioItem } from '../partials/CustomFormRadio.js';

const domainPrice: Price = {
  monthlyRecurringCharge: 545,
};

const hostingOptions: CustomFormRadioItem[] = [
  {
    value: 'Elisa Yritysweb',
    label: 'Elisa Yritysweb',
    monthlyRecurringCharge: 1634,
    oneTimeCharge: undefined,
    isDefault: true,
  },
];

export const defaultHostingOption = (): CustomFormRadioItem | undefined => {
  return hostingOptions.find(it => it.isDefault);
};

export const CorporateWebHostingForm = (props: CustomFormProps) => {
  const { leadFailed, leadInProgress, title, enableCompanyFields = true } = props;
  return (
    <CL.Grid className="of-custom-form">
      <CL.GridRow>
        <CL.GridCol className="title" colWidthS={6} colWidthM={6} colWidthL={12} colWidthXL={12}>
          <h2>{title}</h2>
        </CL.GridCol>
        <CL.GridCol colWidthS={6} colWidthM={6} colWidthL={6} colWidthXL={6}>
          <CustomFormRadio options={hostingOptions} title={t.V9HK(selectProductMsg)} />
          <CustomFormDomainSearch price={domainPrice} />
          <PriceSummary {...props} />
        </CL.GridCol>
        <CL.GridCol colWidthS={6} colWidthM={6} colWidthL={6} colWidthXL={6}>
          <CompanyAndContactDetails enableCompanyFields={enableCompanyFields} />
          <h3 className={dsClass.H4}>{t.GZUK(additionalInformationMsg)}</h3>
          <TextInput label={t.GWJI(domainMsg)} name="domainName" placeholder="" required={true} />
          <CustomFormErrorAndButton leadFailed={leadFailed} leadInProgress={leadInProgress} />
        </CL.GridCol>
      </CL.GridRow>
    </CL.Grid>
  );
};
